/* eslint-disable @typescript-eslint/naming-convention */

/**
 * GPS Provider Interface - Generic interface for all GPS providers
 * All GPS providers (HAPN, Verizon, Geotab, etc.) implement this interface
 *
 * NOTE: Token management (OAuth, caching) is handled by GpsProviderService
 * Provider implementations receive pre-authenticated tokens
 *
 * Note: ExternalProviderRequest/Response already exist in external-credentials.interface.ts (PR 24235)
 */

export interface IGpsProvider {
    /**
     * Get livelink URL for tracking GPS devices
     * @param accessToken Pre-authenticated OAuth access token (managed by GpsProviderService)
     * @param deviceIds Array of GPS device identifiers (e.g., IMEIs)
     * @returns GPS livelink response with tracking URL
     */
    getLivelink(accessToken: string, deviceIds: string[]): Promise<GpsLivelinkResponse>;
}

export interface GpsLivelinkResponse {
    livelink: string;
    expiresAt?: string; // ISO 8601 timestamp
}
